module.exports = __webpack_public_path__ + "img/img_toupiao_nodata.92eb7920.png";